'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = TooltipTrigger;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH Tooltip Trigger Component
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
function TooltipTrigger(props) {
    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        onMouseOver = props.onMouseOver,
        onMouseOut = props.onMouseOut;


    var classNames = (0, _classnames2.default)((0, _defineProperty3.default)({
        'sb-tooltiptrigger': true
    }, '' + className, className));

    return (0, _jsx3.default)('div', {
        className: classNames,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut
    }, void 0, props.children);
}
//# sourceMappingURL=TooltipTrigger.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/tooltip/TooltipTrigger.js
// module id = 623
// module chunks = 0